import {Component} from "@angular/core";
import {AppAlertService} from "./app-alert.service";
import {AppAlertGqlModel} from "./app-alert.gql-model";

@Component({
  selector: "app-alert-container",
  templateUrl: "./app-alert-container.template.pug",
})
export class AppAlertContainerComponent {
  public alerts: AppAlertGqlModel[] = [];

  updateAlerts(alerts: AppAlertGqlModel[]) {
    this.alerts = alerts;
  }

  constructor(private appAlertService: AppAlertService) {
    this.appAlertService.alerts.subscribe(alerts => this.updateAlerts(alerts));
  }
}
